var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPerformanceGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.4066 1.4066) scale(2.81 2.81)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 45,
    r: 45,
    fill: "var(--background-color)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 20.142 66.312 h 10.208 c 0.795 0 1.44 -0.645 1.44 -1.44 V 37.665 c 0 -0.795 -0.645 -1.44 -1.44 -1.44 H 20.142 V 66.312 z",
    fill: "white",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 66.094 43.729 c 2.079 0 3.764 -1.685 3.764 -3.764 c 0 -2.079 -1.685 -3.764 -3.764 -3.764 h -11.93 c 2.076 -3.739 2.139 -15.096 -2.787 -16.46 c -0.933 -0.258 -1.859 0.454 -1.963 1.417 c -0.866 7.97 -5.742 17.877 -10.7 18.164 h -3.862 v 23.755 h 2.003 c 1.078 0 2.108 0.368 3.008 0.963 c 2.245 1.486 6.025 2.356 9.648 2.265 h 1.752 v 0.006 h 12.036 c 2.079 0 3.764 -1.685 3.764 -3.764 s -1.685 -3.764 -3.764 -3.764 h 1.678 c 2.079 0 3.764 -1.685 3.764 -3.764 c 0 -2.079 -1.685 -3.764 -3.764 -3.764 h 1.118 c 2.079 0 3.764 -1.685 3.764 -3.764 S 68.173 43.729 66.094 43.729 z",
    fill: "white",
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerformanceGreen);
export default __webpack_public_path__ + "static/media/performance-green.2fec4e08c4f55cbec4921b07ca44ad46.svg";
export { ForwardRef as ReactComponent };